var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'lbz-checkbox',
    _vm.color && ("lbz-checkbox--" + _vm.color),
    _vm.onBackground && ("lbz-checkbox--on-" + _vm.onBackground),
    {
      'lbz-is-darkened': _vm.darkened,
      'lbz-is-checked': _vm.cisIndeterminate || _vm.cisChecked,
      'lbz-is-indeterminate': _vm.cisIndeterminate,
      'lbz-is-disabled': _vm.disabled
    }
  ],on:{"click":function($event){$event.stopPropagation();!_vm.disabled && _vm.fclick($event)}}},[_c('button',{staticClass:"lbz-checkbox__container"},[_c('input',_vm._b({},'input',{
        id: ("" + _vm.id),
        type: 'checkbox',
        'true-value': ("" + _vm.trueValue),
        'false-value': ("" + _vm.falseValue),
        value: _vm.cisGroup ? ("" + _vm.value) : '',
        checked: _vm.cisChecked,
        disabled: _vm.disabled
      },false)),_c('div',{staticClass:"lbz-checkbox__square"},[_c('svg',{staticClass:"lbz-checkbox__checkmark",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M1.73,12.91 8.1,19.28 22.79,4.59","fill":"none"}})]),_c('span',{staticClass:"lbz-checkbox__mixedmark"})]),(!_vm.disabled)?_c('lbz-state',_vm._b({},'lbz-state',_vm.cgetStateAttrs,false)):_vm._e()],1),(_vm.$slots.default)?_c('label',{staticClass:"lbz-checkbox__label",attrs:{"for":("" + _vm.id)}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }